var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { getColorByStatus } from 'src/shared/helpers/viewsHelpers';
import { E_STATUS } from 'src/shared/types';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import styles from './ControlItem.module.scss';
var getIcon = function (status) {
    switch (status) {
        case E_STATUS.OK: {
            return E_ICONS.CHECK;
        }
        case E_STATUS.KO: {
            return E_ICONS.CLOSE;
        }
        case E_STATUS.UNKNOWN:
        default: {
            return E_ICONS.WARNING;
        }
    }
};
export var ControlItem = function (props) {
    var description = props.description, status = props.status, values = props.values, scoreTags = props.scoreTags, className = props.className;
    var controlItemClassname = classNames(styles.controlItemWrapper, className);
    return (_jsxs("div", __assign({ className: controlItemClassname }, { children: [_jsx(Icons, { icon: getIcon(status), className: styles.iconStatus, color: getColorByStatus(status) }), _jsxs("div", __assign({ className: styles.infoWrapper }, { children: [_jsx("p", { children: description }), values.length > 0 && (_jsx("ul", __assign({ className: styles.valuesList }, { children: values.map(function (item) { return (_jsx("li", __assign({ style: { color: getColorByStatus(status) } }, { children: item }), item)); }) }))), (scoreTags === null || scoreTags === void 0 ? void 0 : scoreTags.length) > 0 && (_jsx("ul", __assign({ className: styles.controlTagList }, { children: scoreTags.map(function (scoreTag) { return (_jsx("li", __assign({ className: styles.controlTagListItem }, { children: scoreTag }), scoreTag)); }) })))] }))] })));
};
